import { Link } from "react-router-dom";

const Terms = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="mb-6">
        <Link to="/" className="text-primary hover:underline">&larr; Back Home</Link>
      </div>
      <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
      <div className="prose prose-gray max-w-none">
        <p className="mb-4">Last updated: February 2024</p>
        
        <h2 className="text-2xl font-semibold mt-6 mb-4">1. Agreement to Terms</h2>
        <p>By accessing or using UPnGOTrainerPad, you agree to be bound by these Terms of Service.</p>
        
        <h2 className="text-2xl font-semibold mt-6 mb-4">2. Use License</h2>
        <p>Permission is granted to temporarily access the materials on UPnGOTrainerPad's website for personal, non-commercial transitory viewing only.</p>
        
        <h2 className="text-2xl font-semibold mt-6 mb-4">3. Disclaimer</h2>
        <p>The materials on UPnGOTrainerPad's website are provided on an 'as is' basis.</p>
        
        <h2 className="text-2xl font-semibold mt-6 mb-4">4. Limitations</h2>
        <p>In no event shall UPnGOTrainerPad or its suppliers be liable for any damages arising out of the use or inability to use the materials on the website.</p>
        
        <h2 className="text-2xl font-semibold mt-6 mb-4">5. Contact Us</h2>
        <p>If you have any questions about these Terms, please contact us at:</p>
        <p>Email: info@upngoTrainerPad.co.uk</p>
      </div>
    </div>
  );
};

export default Terms;